module.exports = __webpack_public_path__ + "img/Awards.30ef694c.svg";